import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import React from 'react';
import { observer } from 'mobx-react';

const Alert = observer(({ automationStore }) => {
  const handleClose = (e) => {
    automationStore.clearAlert();
  }
  return (
    <Dialog
      open={automationStore.alert !== null}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {automationStore.alertMessage}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} autoFocus>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
});

export default Alert;
